import React from 'react';

const ContactsPage = () => {
  return <h1>Hello contacts page</h1>;
};

export default ContactsPage;
